import { SECTION_HELP } from './helpkitText';
import { ISectionHelpItem } from './interface/helpkit.interface';

/**
 * Looks up a help entry by dotted key (e.g. `pages.layout`).
 * The part before the dot is the menu; after the dot is the section.
 * If no section is given, defaults to `header`.
 */
export const getSectionHelp = (
  sectionKey: string
): ISectionHelpItem | undefined => {
  const [menu, section = 'header'] = sectionKey.split('.');
  return SECTION_HELP[menu]?.[section];
};
